export const VERSIONS = {
    version: window.__VERSION,
    admin: window.__ADMIN_VERSION,
    releaseDate: window.__RELEASE_DATE
};
